import React from 'react';
import {
  Paper,
  IconButton,
  Typography,
  Button,
  Tooltip,
  Zoom,
  Avatar,
  AvatarGroup,
} from '@mui/material';
import {
  CompareArrows as CompareIcon,
  Close as CloseIcon,
  ArrowForward as ArrowIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useCompare } from '../context/CompareContext';
import { sanitizeImageUrl } from '../utils/image';

const CompareFloatingBar = () => {
  const navigate = useNavigate();
  const { compareItems, removeFromCompare, clearCompare, compareCount } =
    useCompare();

  if (compareCount === 0) return null;

  return (
    <Zoom in={compareCount > 0}>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 100,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          py: 1.5,
          borderRadius: 3,
          bgcolor: 'primary.main',
          color: 'white',
          zIndex: 1200,
          maxWidth: '90vw',
        }}
      >
        <CompareIcon />

        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Сравнение ({compareCount}/4)
        </Typography>

        {/* Product avatars */}
        <AvatarGroup max={4} sx={{ mx: 1 }}>
          {compareItems.map((product) => (
            <Tooltip
              key={product.id}
              title={
                typeof product.name === 'object'
                  ? product.name.ru
                  : product.name
              }
            >
              <Avatar
                src={sanitizeImageUrl(product.image)}
                alt=""
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: 'white',
                  cursor: 'pointer',
                  '&:hover': { opacity: 0.8 },
                }}
                onClick={() => removeFromCompare(product.id)}
              />
            </Tooltip>
          ))}
        </AvatarGroup>

        <Button
          variant="contained"
          size="small"
          endIcon={<ArrowIcon />}
          onClick={() => navigate('/compare')}
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            fontWeight: 600,
            '&:hover': { bgcolor: 'grey.100' },
          }}
        >
          Сравнить
        </Button>

        <IconButton
          size="small"
          onClick={clearCompare}
          sx={{ color: 'white', ml: -1, minWidth: 44, minHeight: 44 }}
          aria-label="Очистить сравнение"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Zoom>
  );
};

export default CompareFloatingBar;
